import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { SuitesNavbarItem } from "../../SharedSuite/Navbar/SuitesNavbarItem";
import { useNavigate } from "react-router-dom";
import AddCredits from "../../CreditsScenario/AddCredits";
import { useAppSelector } from "../../../store/hooks";
import UpgradePlanButton from "../../main-page/components/get-conversation/UpgradePlanButton";
import { SignInRegisterButtons } from "../../../shared/SignIn&RegisterButtons";
import UserProfile from "../../main-page/components/get-conversation/UserProfile";
import AvailablePackagesModal from "../../CreditsScenario/AvailablePackagesModal";
import { VideoLibraryIcon } from "../../../Custom-imeges/InspirationLibrary/VideoLibraryIcon";
import {
  InspirationLibraryApps,
  InspirationLibraryRoutes,
} from "../InspirationLibraryHelper";
import { ImageLibraryIcon } from "../../../Custom-imeges/InspirationLibrary/ImageLibraryIcon";

const LibraryNavBar = () => {
  const navigate = useNavigate();
  const User = useAppSelector((s) => s.User);
  const [activeLibrary, setActiveLibrary] = useState("");
  const [showAvailablePackages, setShowAvailablePackages] =
    useState<boolean>(false);

  const LibraryApps = [
    {
      appName: InspirationLibraryApps.imageLibrary,
      appIcon: (
        <ImageLibraryIcon
          className={`library-app-icn fill${
            activeLibrary === InspirationLibraryApps.imageLibrary
              ? "active"
              : ""
          }`}
        />
      ),
    },
    {
      appName: InspirationLibraryApps.videoLibrary,
      appIcon: (
        <VideoLibraryIcon
          className={`library-app-icn stroke${
            activeLibrary === InspirationLibraryApps.videoLibrary
              ? "active"
              : ""
          }`}
        />
      ),
    },
  ];

  useEffect(() => {
    if (
      window.location.pathname.includes(InspirationLibraryRoutes.videoLibrary)
    ) {
      setActiveLibrary(InspirationLibraryApps.videoLibrary);
    } else if (
      window.location.pathname.includes(InspirationLibraryRoutes.imageLibrary)
    ) {
      setActiveLibrary(InspirationLibraryApps.imageLibrary);
    }
  }, [window.location.pathname]);

  const handleSetActiveLibraryApp = (appName: string) => {
    if (appName !== activeLibrary) {
      setActiveLibrary(appName);

      if (appName === InspirationLibraryApps.videoLibrary) {
        navigate(InspirationLibraryRoutes.videoLibrary);
      } else if (appName === InspirationLibraryApps.imageLibrary) {
        navigate(InspirationLibraryRoutes.imageLibrary);
      }
    }
  };

  return (
    <Box className="inspiration-library-navbar">
      <Box className="library-navbar-apps">
        <Box className="apps" sx={{gap:"2rem !important"}}>
          {LibraryApps.map((app) => (
            <Box
              sx={{minWidth: "100px" }}
              key={app.appName}
              onClick={() => handleSetActiveLibraryApp(app.appName)}
            >
              <SuitesNavbarItem
                appTitle={app.appName}
                appIcon={app.appIcon}
                activeApp={activeLibrary}
              />
            </Box>
          ))}
        </Box>
        <Box
          sx={{
            width: "fit-content",
            maxWidth: "500px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "8px",
            justifyContent: "space-between",
            marginBottom: "8px",
            "@media (max-width: 900px)": {
              display: "none",
            },
          }}
        >
          <Box>
            <AddCredits
              showAvailablePackages={showAvailablePackages}
              setShowAvailablePackages={setShowAvailablePackages}
            />
          </Box>
          {User.IsAuthenticated && !User.isSubscribed ? (
            <UpgradePlanButton />
          ) : !User.IsAuthenticated ? (
            <Box className="signin-actions">
              <SignInRegisterButtons />
            </Box>
          ) : (
            <Box></Box>
          )}
          {User.IsAuthenticated && <UserProfile />}
        </Box>
      </Box>
      {showAvailablePackages && (
        <AvailablePackagesModal
          show={showAvailablePackages}
          handleClose={() => setShowAvailablePackages(false)}
        />
      )}
    </Box>
  );
};

export default LibraryNavBar;
